<template>
  <div>
    <div style="display: flex; align-items: center">
      <el-select
        v-model="classIndex"
        placeholder="请选择班级"
        @change="onChangeClass"
      >
        <el-option
          v-for="(item, index) in classList"
          :key="item.Id"
          :label="item.GradeNameAndClassName"
          :value="index"
        >
        </el-option>
      </el-select>
      <el-select v-model="cycleIndex" placeholder="请选择周期" class="m-left">
        <el-option
          v-for="(item, index) in cycleInfoData"
          :key="item.Id"
          :label="item.Name"
          :value="index"
        >
        </el-option>
      </el-select>
      <el-select
        class="m-left"
        v-model="yearValue"
        @change="yearListChange()"
        placeholder="请选择"
      >
        <el-option
          v-for="item in yearList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <!-- <el-select v-model="domainIndex" placeholder="请选择领域" class="m-left">
      <el-option
        v-for="(item, index) in domainList"
        :key="item.CateId"
        :label="item.CateName"
        :value="index"
      >
      </el-option>
    </el-select> -->
      <!-- <el-select v-model="statusValue" placeholder="请选择状态" class="m-left">
      <el-option
        v-for="item in statusList"
        :key="item.Id"
        :label="item.Name"
        :value="item.Id"
      >
      </el-option>
    </el-select> -->
      <el-input
        placeholder="请输入学生名称"
        v-model="StudentName"
        class="input-with-select m-left"
        style="width: 150px"
      >
      </el-input>
      <el-input
        placeholder="请输入报告名称"
        v-model="searchName"
        class="input-with-select m-left"
      >
      </el-input>
      <el-button type="goon" class="m-left" @click="onClickSearch"
        >查询</el-button
      >
      <el-button
        type="goon"
        class="m-left"
        :disabled="tableData.length == 0"
        @click="onClickOpen"
        >导出</el-button
      >
      <el-button type="goon" class="m-left" @click="onEmpty">清空</el-button>
    </div>
    <!-- 评价表格 -->
    <el-row style="margin-top: 40px">
      <el-col>
        <!-- <el-card> -->
        <div class="flex-items" v-if="testInfo && testInfo.length != 0">
          <div class="flex-items" style="margin-right: 0.25rem">
            <i
              class="el-icon-success"
              style="font-size: 0.35rem; color: #67cd50"
            ></i>
            <div style="font-size: 0.2rem; margin-left: 0.0625rem">
              已评：{{ testInfo[0].value }}人
            </div>
          </div>
          <div class="flex-items">
            <i
              class="el-icon-warning"
              style="font-size: 0.35rem; color: #fb6e22"
            ></i>
            <div style="font-size: 0.2rem; margin-left: 0.0625rem">
              未评：{{ testInfo[1].value }}人
            </div>
          </div>
        </div>
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 0.25rem"
          border
          :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
        >
          <el-table-column prop="TempType" label="学年" align="center">
          </el-table-column>
          <el-table-column prop="StudyYearName" label="学届" align="center">
          </el-table-column>
          <el-table-column prop="GradeName" label="年级" align="center">
          </el-table-column>
          <el-table-column prop="ClassName" label="班级" align="center">
          </el-table-column>
          <el-table-column prop="StudentName" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="TempTitle" label="名称" align="center">
          </el-table-column>
          <el-table-column prop="ProGress" label="完成进度" align="center">
          </el-table-column>
          <el-table-column prop="Status" label="完成状态" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.Status == 1" type="success"
                >已完成</el-tag
              >
              <el-tag v-else type="warning">未完成</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            layout="sizes, prev, pager, next"
            @current-change="PageSizeChange"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="PageSize"
            :total="dataCount"
          >
          </el-pagination>
        </div>
        <!-- </el-card> -->
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  FrontGetQuestionCategoryNodes,
  GetTeacherClassRoleInfo,
  GetOpenCycleInfoSelectResult,
  WebGrowIsTestList,
  WebGrowStudentList,
} from "@/api/api.js";
import uploadUrl from "../../../api/api";

export default {
  data() {
    return {
      classList: [],
      classIndex: 0,
      cycleInfoData: [],
      cycleIndex: 0,
      domainList: [],
      domainIndex: 0,
      statusList: [
        {
          Name: "已评",
          Id: 1,
        },
        {
          Name: "未评",
          Id: 0,
        },
      ],
      statusValue: "",
      searchName: "",
      StudentName: "",
      tableData: [],
      testInfo: [],
      yearList: [],
      yearValue: "",
      PageIndex: 1, // 分页
      PageSize: 20,
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    await this.GetTeacherClassRoleInfo();
    await this.GetOpenCycleInfoSelectResult();
    this.getYearList();

    // await this.FrontGetQuestionCategoryNodes();
    await this.WebGrowIsTestList();
    await this.WebGrowStudentList();
  },
  methods: {
    async onClickOpen() {
      window.open(
        `${
          uploadUrl.uploadUrl
        }/api/mgd/Eval_Growth/Export_WebGrowStudentList?ClassId=${
          this.classList[this.classIndex].Id
        }&Status=${
          this.statusValue == "" ? -1 : this.statusValue
        }&StudyYearId=${
          this.classList[this.classIndex].StudyYearId || 0
        }&Year=${this.yearValue ? this.yearValue : 0}&className=${
          this.classList[this.classIndex].ClassName
        }&gradeName=${this.classList[this.classIndex].GradeName}&Name=${
          this.searchName
        }&UserId=${this.userInfo.uID}&StudentName=${this.StudentName}`,
        "_brank"
      );
    },
    PageSizeChange(e) {
      this.PageIndex = e;
      this.WebGrowStudentList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.WebGrowStudentList();
    },
    // 获取年份列表
    getYearList() {
      this.yearList = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear() + 3;
      for (let index = 6; index >= 0; index--) {
        this.yearList.push({
          Id: year - index,
          Name: year - index,
        });
      }
    },
    onChangeClass() {
      //console.log(123);
      this.GetOpenCycleInfoSelectResult();
    },
    onEmpty() {
      this.statusValue = "";
      this.searchName = "";
      this.yearValue = "";
      this.StudentName = "";
      this.WebGrowIsTestList();
      this.WebGrowStudentList();
    },
    // 获取成长足迹列表
    async WebGrowStudentList() {
      //console.log(this.classList, "classList");
      let xhr = await WebGrowStudentList({
        StudyYearId: this.classList[this.classIndex].StudyYearId,
        Year: this.yearValue ? this.yearValue : 0,
        ClassId: this.classList[this.classIndex].Id,
        GradeId: this.classList[this.classIndex].GradeId,
        className: this.classList[this.classIndex].ClassName,
        gradeName: this.classList[this.classIndex].GradeName,
        status: this.statusValue == "" ? -1 : this.statusValue,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.searchName,
        StudentName: this.StudentName,
      });
      if (xhr.data.success) {
        this.tableData = xhr.data.response.data;
      } else {
        this.tableData = [];
      }
    },
    // 学期评价数量
    async WebGrowIsTestList() {
      let res = await WebGrowIsTestList({
        StudyYearId: this.classList[this.classIndex].StudyYearId,
        Year: this.yearValue ? this.yearValue : 0,
        ClassId: this.classList[this.classIndex].Id,
        GradeId: this.classList[this.classIndex].GradeId,
        className: this.classList[this.classIndex].ClassName,
        gradeName: this.classList[this.classIndex].GradeName,
        status: this.statusValue == "" ? -1 : this.statusValue,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.searchName,
        StudentName: this.StudentName,
      });
      if (res.data.success) {
        this.testInfo = res.data.response;
      }
    },
    // 查询
    onClickSearch() {
      this.WebGrowIsTestList();
      this.WebGrowStudentList();
    },
    //   选择领域
    async FrontGetQuestionCategoryNodes() {
      let res = await FrontGetQuestionCategoryNodes({
        IsBaby: this.cycleInfoData[this.cycleIndex].IsBaby,
        BabyLevel: this.cycleInfoData[this.cycleIndex].BabyLevel,
      });
      if (res.data.success) {
        this.domainList = res.data.response;
      }
    },
    async GetOpenCycleInfoSelectResult() {
      let res = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
        StudyYearsId: this.classList[this.classIndex].StudyYearId,
      });
      if (res.data.success) {
        this.cycleInfoData = res.data.response;
      }
    },
    // 获取幼儿下拉数据
    async GetTeacherClassRoleInfo() {
      let xhr = await GetTeacherClassRoleInfo();
      let themeArr = [];
      let classArr = [];
      if (this.userInfo.UserIdentity == "1") {
        classArr.push({
          GradeNameAndClassName: "全园",
          ClassName: "全园",
          GradeName: "全园",
          Id: 0,
        });
      }
      xhr.data.response.forEach((Gradeitem) => {
        Gradeitem.ClassInfo.forEach((classItem) => {
          classArr.push({
            GradeNameAndClassName:
              Gradeitem.GradeName + (classItem.Name ? classItem.Name : ""),
            ClassName: classItem.Name ? classItem.Name : "",
            Id: classItem.Id,
            ...Gradeitem,
          });
        });
      });
      this.classList = classArr;
      //console.log(this.classList);
    },
    onClick(e) {},
  },
};
</script>
<style lang="less" scoped>
.m-left {
  margin-left: 20px;
}
.input-with-select {
  width: 300px;
}
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.pagination {
  margin-top: 30px;
}
</style>